<div class="brand-management">
  <div class="header-row">
    <button mat-fab color="primary" type="button" (click)="openAdd()" [disabled]="!corporationID"
      [attr.aria-label]="'brandManagement.addBrand' | transloco"
      data-testid="add-brand-button">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  @if (loading) {
    <div class="muted">{{ 'brandManagement.loadingBrands' | transloco }}</div>
  }

  @if (!loading && brands.length === 0) {
    <div class="muted">{{ 'brandManagement.noBrandsYetAddOneTo' | transloco }}</div>
  }

  <div class="brand-list">
    @for (brand of brands; track brand.id) {
      <div class="brand-row">
        <div class="brand-display">
          @if (logoUrls[brand.id]) {
            <img class="brand-logo" [src]="logoUrls[brand.id]" alt="" />
          } @else {
            <span class="brand-swatch" [style.background-color]="swatchFor(brand) ?? 'transparent'"></span>
          }
          <span class="brand-name">{{ brand.name }}</span>
          <span class="spacer"></span>
          <button mat-icon-button color="primary" type="button" (click)="openEdit(brand)"
            [attr.aria-label]="'brandManagement.editBrand' | transloco" data-testid="edit-brand-button">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button type="button" color="warn" (click)="confirmDelete(brand)"
            [attr.aria-label]="'brandManagement.deleteBrand' | transloco" data-testid="delete-brand-button">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>
